export const heroBadges = [
  'Material 100% digital',
  'Acceso inmediato',
  'Recursos listos para usar',
  '7 tomos + 5 bonos',
  'Para Secundaria',
]

export const painPoints: string[] = [
  '«Necesito preparar una actividad para mañana y no sé por dónde empezar.»',
  '«Paso horas buscando materiales que realmente pueda usar.»',
  '«Tengo que trabajar bullying, vínculos, redes o salud mental y necesito una propuesta concreta.»',
  '«Quiero hacer una jornada ESI, pero organizarla desde cero lleva demasiado tiempo.»',
  '«Encuentro información, pero no actividades listas para llevar al aula.»',
  '«Necesito trabajar temas sensibles y no siempre sé cómo iniciar la conversación.»',
]

export interface ComparisonRow {
  sin: string
  con: string
}

export const comparison: ComparisonRow[] = [
  { sin: 'Buscar ideas durante horas', con: 'Abrir el Mega Pack' },
  { sin: 'Abrir decenas de páginas', con: 'Elegir el tema' },
  { sin: 'Adaptar materiales encontrados', con: 'Encontrar una propuesta concreta' },
  { sin: 'Pensar actividades desde cero', con: 'Adaptarla si querés' },
  { sin: 'No saber cómo abordar temas sensibles', con: 'Llevarla directamente al aula' },
  { sin: 'Llegar a clase improvisando', con: 'Ahorrar tiempo y energía' },
]

export const usos: string[] = [
  'Clases habituales',
  'Tutorías',
  'ESI',
  'Jornadas institucionales',
  'Debates',
  'Trabajo grupal',
  'Proyectos',
  'Actividades de reflexión',
  'Educación digital',
  'Convivencia escolar',
  'Espacios de orientación',
  'Actividades interdisciplinarias',
]

export type AudienceIcon =
  | 'docente'
  | 'tutor'
  | 'equipo'
  | 'orientador'
  | 'profesional'
  | 'digital'

export interface Audience {
  icon: AudienceIcon
  titulo: string
  descripcion: string
}

export const audience: Audience[] = [
  {
    icon: 'docente',
    titulo: 'Docentes de Secundaria',
    descripcion:
      'Que necesitan propuestas concretas para llevar al aula sin prepararlas desde cero.',
  },
  {
    icon: 'tutor',
    titulo: 'Tutores y preceptores',
    descripcion:
      'Que acompañan grupos y buscan dinámicas para trabajar vínculos y convivencia.',
  },
  {
    icon: 'equipo',
    titulo: 'Equipos educativos',
    descripcion:
      'Que organizan jornadas, talleres y proyectos institucionales durante el año.',
  },
  {
    icon: 'orientador',
    titulo: 'Orientadores',
    descripcion:
      'Que necesitan materiales para espacios de orientación y trabajo con grupos.',
  },
  {
    icon: 'profesional',
    titulo: 'Profesionales que trabajan con adolescentes',
    descripcion:
      'Que buscan casos, disparadores y actividades cercanas a su realidad.',
  },
  {
    icon: 'digital',
    titulo: 'Docentes de ciudadanía digital',
    descripcion:
      'Que necesitan recursos actualizados sobre redes, privacidad e identidad digital.',
  },
]

export interface Faq {
  pregunta: string
  respuesta: string
}

export const faqs: Faq[] = [
  {
    pregunta: '¿Cómo recibo el Mega Pack?',
    respuesta:
      'Después de completar el pago recibís el acceso al material digital. Podés empezar a utilizarlo inmediatamente.',
  },
  {
    pregunta: '¿Es físico o digital?',
    respuesta:
      'Es un producto 100% digital. No tenés que esperar ningún envío.',
  },
  {
    pregunta: '¿Para qué años de Secundaria sirve?',
    respuesta:
      'Incluye propuestas para distintos niveles de Secundaria. Podés seleccionar y adaptar cada actividad según el grupo, el año y el contexto.',
  },
  {
    pregunta: '¿Sirve para trabajar ESI?',
    respuesta:
      'Sí. Gran parte del material está pensado para abordar contenidos de ESI a través de actividades, casos y jornadas listas para implementar.',
  },
  {
    pregunta: '¿Puedo usarlo en tutorías y jornadas institucionales?',
    respuesta:
      'Sí. Las propuestas sirven para clases, tutorías, talleres, jornadas y proyectos interdisciplinarios.',
  },
  {
    pregunta: '¿Necesito imprimir todo?',
    respuesta:
      'No. Podés proyectar las actividades, compartirlas en formato digital o imprimir solo lo que necesites.',
  },
  {
    pregunta: '¿Las actividades están listas para usar?',
    respuesta:
      'Sí. Están redactadas como propuestas concretas con consignas y preguntas disparadoras, y podés adaptarlas a tu grupo.',
  },
  {
    pregunta: '¿La guía de temas sensibles reemplaza a un profesional?',
    respuesta:
      'No. Es una orientación pedagógica para preparar y moderar conversaciones. No reemplaza la intervención de profesionales ni los protocolos institucionales cuando corresponda.',
  },
  {
    pregunta: '¿Qué diferencia tiene con buscar recursos gratis en Internet?',
    respuesta:
      'La organización. En Internet encontrás información dispersa; acá tenés 12 recursos ordenados por tema y listos para llevar al aula.',
  },
  {
    pregunta: '¿Los bonos están incluidos?',
    respuesta: 'Sí. Los 5 bonos están incluidos sin costo adicional.',
  },
  {
    pregunta: '¿Puedo usarlo durante todo el año?',
    respuesta:
      'Sí. Es una biblioteca para reutilizar: elegís el recurso que necesitás en cada momento del ciclo lectivo.',
  },
  {
    pregunta: '¿Tiene garantía?',
    respuesta: 'Sí. Contás con 7 días de garantía para conocer el producto.',
  },
]

export const productImage =
  'https://cdn.magicpatterns.com/uploads/1QkiMNsaPsEwQpVqLmnyX6/ChatGPT_Image_14_sept_2026,_03_48_28_p.m..png'
